module.exports = __webpack_public_path__ + "img/1366476974.6464b5a8.jpg";